import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface MessageBubbleProps extends BoxProps {
  children: ReactNode;
}

function MessageBubble({ children, ...props }: MessageBubbleProps) {
  return (
    <Box
      className="MessageBubble"
      bg="white"
      rounded="xl"
      p="10px 16px"
      pos="relative"
      overflow="hidden"
      {...props}
    >
      {children}
    </Box>
  );
}

const MemoizedMessageBubble = memo(MessageBubble);
export { MemoizedMessageBubble as MessageBubble };
